import React, { useState, useEffect, Fragment } from "react";
import { connect } from "react-redux";
import stateMap from "store/stateMap";
import { useLocation } from "react-router-dom";
import { createBrowserHistory, parsePath } from "history";
import { createSearchParams } from "react-router-dom";
import { PagesList } from "component/Pages";
import api from "api";
import Breadcrumb from "component/Breadcrumb";
import BlockHeader from "component/BlockHeader/BlockHeader";
import PaginationWrapper from "component/Pagination";    
import _ from "lodash";
import Header from "component/Header/Header";
import Footer from "component/Footer/Footer";
import update from "immutability-helper";
import "./style.scss";
import { PageCredential } from "component/PageCredential";

export default connect(stateMap)((props) => {

    const [pages, setPages] = useState(false);
    let location                                = useLocation();
    let history                                 = createBrowserHistory();
    const [countPages, setCountPage] = useState(false);
    const [dataLoading, setDataLoading]         = useState(false) ;
    const queryString                           = new URLSearchParams(parsePath(window.location.href).search || '');
    const [parameter, setParameter]             = useState({
        paged           : parseInt(queryString.get('page') || 1)  
        ,posts_per_page : parseInt(queryString.get('posts_per_page')) || 20
    });


    const changeParams = (e) => {
        e.preventDefault();

        if(dataLoading)
        {
            return;
        }

        let [toUpdateFilter, updatedValue] = e.currentTarget.name.split(':');

        setParameter(
            update(parameter, { $apply : function(params){

                if(params[toUpdateFilter] == updatedValue)
                {
                    params[toUpdateFilter] = '';
                }
                else
                {
                    params[toUpdateFilter] = updatedValue;
                }
    
                params.paged = 1;
    
                return _.assign({}, params);
    
            }})
        );
    }

    const loadTalent = () => {

        if(!props.auth.user)
        {
            return;
        }

        if(dataLoading)
        {
            return;
        }

        var DataToLoad = [
            api('/Pages', 'get', _.assign({

            }, parameter))
        ];

        if(parameter.paged === 1)
        {
            DataToLoad.push(
                api('/Pages', 'get', _.assign({get_total : 1}, parameter))
            );
        }

        setDataLoading(true);

        Promise.all(DataToLoad)
            .then((response) => {
                setDataLoading(false);

                setPages(response[0].page);

                history.replace(
                    { search: `?${createSearchParams(parameter)}`}
                );

                if(parameter.paged === 1)
                {
                    setCountPage( parseInt(response[1].page) );
                }

            })
            .catch((error) => {
                setDataLoading(false);
                
            })
    }
    
    useEffect(loadTalent, [props.auth.user, parameter]);

    return(
        <>
            <Header/>
            <PageCredential title="Pages" />
            <div className="container relative" >
                <div className="page-archive-container">

                    <Breadcrumb
                        items={[
                            ['/', 'Crowdbees']
                            ,['Pages']
                        ]}
                    />
                    <div className="talents-list">
                        {
                            pages === false ? <span className="skeleton"></span>:
                            (
                                <Fragment>
                                    {
                                        dataLoading ? <div><span className="skeleton"></span></div> :
                                        <>
                                            { 
                                                <BlockHeader title="Pages"/>
                                            }

                                            <PagesList pages={pages}/>

                                            <PaginationWrapper
                                                className="mt-4"
                                                activePage={parameter.paged}
                                                itemsCountPerPage={parameter.posts_per_page}
                                                totalItemsCount={countPages}
                                                pageRangeDisplayed={5}
                                                onChange={(pagenumber) => {
                                                    setParameter(update(parameter, { paged : {$set : pagenumber } }))
                                                }}
                                            />
                                        </>
                                    }
                                </Fragment>
                            )
                        }
                    </div>
                </div>
            </div>
            <Footer/>
        </>
    )
});